<template>
  <carousel-wrapper
    :element-key="elementKey"
    :element-data="elementData"
    :display-name="displayname"
    icon-name="icons latest-posts" 
    :children="elementData.post"/>
</template>

<script>
import { unref } from "vue";
import CarouselWrapper from "@/components/card/CarouselWrapper";

export default {
  name: "LastestPostsBox",
  inject: {
    cardMetaRef: { from: 'cardMeta', default: () => ({}) }
  },
  props: {
    elementKey: String,
    elementData: Object,
  },
  components: {
    CarouselWrapper,
  },

  computed: {
    cardMeta() {
      return unref(this.cardMetaRef) || {};
    },
    displayname() {
      const term = this.cardMeta.keyword;
      return "Latest Posts From " + term;
    }
  },
};
</script>

<scss lang="scss" scoped>

</scss>
